import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { Popover } from "components/Popover/Popover";
import { getUserData } from "containers/Auth/Auth.selectors";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { signOutPath } from "utils/RouterManager/constants";
import { mapScreensToPaths } from "utils/RouterManager/utils";
import { getRelativeUrl } from "utils/service";
import "./ProfilePopover.scss";

const ProfilePopover = () => {
    const userData = useSelector(getUserData);

    const trigger = userData?.icon ? (
        <img
            className="profilePopover__photo"
            src={userData?.icon}
            alt={userData?.name}
            data-testid="profileIcon"
        />
    ) : (
        <span
            className="profilePopover__photo profilePopover__photo--empty"
            data-testid="profileIcon"
        >
            <Icon icon={IconCollection.accountOutline} />
        </span>
    );

    return (
        <Popover
            trigger={trigger}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: -14,
                horizontal: "right",
            }}
            toggleClassName="profile__toggle"
            contentClassName="profilePopover"
            rootClassName="topbarPopover"
        >
            <ul>
                <li>
                    <Link to={getRelativeUrl("user", userData?.identity_id)}>
                        <Icon icon={IconCollection.accountOutline} />
                        Edit profile
                    </Link>
                </li>
                <li>
                    <Link
                        to={mapScreensToPaths.userRoleManagement}
                        data-testid="manageUsersRolesButton"
                    >
                        <Icon icon={IconCollection.shieldAccountOutline} />
                        Manage Users & Roles
                    </Link>
                </li>
                <li>
                    <Link to={signOutPath}>
                        <Icon icon={IconCollection.logoutVariant} />
                        Logout
                    </Link>
                </li>
            </ul>
        </Popover>
    );
};

export default ProfilePopover;
